import React from 'react'
import accounting from 'accounting'

const Importo = ({ importo, numDecimali = 2, ...rest }) => {
  return <span {...rest}>{accounting.formatMoney(importo, '€ ', numDecimali, '.', ',')}</span>
}

export default Importo
